'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Redirect$PvpcontrollerWeb = require("./Redirect.js");

var search = Curry._1(Css.style, {
      hd: Css.width(Css.px(200)),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.alignItems(Css.center),
          tl: {
            hd: Css.marginLeft(Css.auto),
            tl: /* [] */0
          }
        }
      }
    });

var searchInput = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.subTitleColor),
      tl: /* [] */0
    });

var icon = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.titleColor),
      tl: {
        hd: Css.fontSize(Css.px(20)),
        tl: /* [] */0
      }
    });

function Search(Props) {
  var terms = Props.terms;
  var rootUrl = Props.rootUrl;
  var onSearchResults = Props.onSearchResults;
  var onSearchPending = Props.onSearchPending;
  var onSearchCancel = Props.onSearchCancel;
  var search$1 = Props.search;
  var match = React.useState(function () {
        if (terms.length > 0) {
          return {
                  TAG: /* Searching */1,
                  _0: terms
                };
        } else {
          return /* NoSearch */0;
        }
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (typeof state === "number") {
            return ;
          }
          switch (state.TAG | 0) {
            case /* WaitingToSearch */0 :
                var terms = state._0;
                if (terms.length > 0) {
                  Curry._1(onSearchPending, terms);
                  var id = setTimeout((function (param) {
                          return Curry._1(setState, (function (_previousState) {
                                        return {
                                                TAG: /* Searching */1,
                                                _0: terms
                                              };
                                      }));
                        }), 300);
                  return (function (param) {
                            clearTimeout(id);
                            
                          });
                } else {
                  Curry._1(onSearchCancel, undefined);
                  return ;
                }
            case /* Searching */1 :
                var terms$1 = state._0;
                return Curry._2(search$1, terms$1, (function (results) {
                              return Curry._1(setState, (function (_previousState) {
                                            return {
                                                    TAG: /* Results */2,
                                                    _0: terms$1,
                                                    _1: results
                                                  };
                                          }));
                            }));
            case /* Results */2 :
                Curry._2(onSearchResults, state._0, state._1);
                return ;
            
          }
        }), [state]);
  var tmp;
  tmp = typeof state === "number" || state.TAG !== /* Searching */1 ? React.createElement(React.Fragment, undefined) : React.createElement(Redirect$PvpcontrollerWeb.make, Redirect$PvpcontrollerWeb.makeProps(rootUrl + "/search/" + state._0, undefined, undefined));
  return React.createElement(React.Fragment, undefined, tmp, React.createElement("div", {
                  className: search
                }, React.createElement("input", {
                      className: searchInput,
                      placeholder: "Search...",
                      type: "text",
                      onChange: (function (param) {
                          var value = param.target.value;
                          return Curry._1(setState, (function (_previousState) {
                                        return {
                                                TAG: /* WaitingToSearch */0,
                                                _0: value
                                              };
                                      }));
                        })
                    }), React.createElement("i", {
                      className: "fas fa-search " + icon
                    })));
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7) {
  var tmp = {
    terms: prim0,
    rootUrl: prim1,
    onSearchResults: prim2,
    onSearchPending: prim3,
    onSearchCancel: prim4,
    search: prim5
  };
  if (prim6 !== undefined) {
    tmp.key = prim6;
  }
  return tmp;
}

var make = Search;

exports.makeProps = makeProps;
exports.make = make;
/* search Not a pure module */
